import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Page, Button, Container, Box } from "@common-ui/ui";
import { Auth } from "aws-amplify";

import { Header, ToggleViews } from "../../components";
import { CustomerTableView } from "./CustomerTableView";
import { CustomerListView } from "./CustomerListView";
import { CustomerCardView } from "./CustomerCardView";

import { CreateCustomerDialog } from "./CreateCustomerDialog";

import { getUserCustomers } from "../../services";
import { Add } from "@mui/icons-material";

import { RemoveCustomerDialog } from "./RemoveCustomerDialog";
import { useSelector } from "react-redux";
export const Customers = () => {
  const currentOrganization = useSelector(
    (state) => state.organization.currentOrganization
  );
  let appRole = currentOrganization?.app_role;
  let doesUserHavePermission = appRole === "ADMIN";

  const [view, setView] = useState("table-view");
  const [customers, setCustomers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [openRemoveDialog, setOpenRemoveDialog] = React.useState(false);
  const [currentCustomerId, setCurrentCustomerId] = React.useState(undefined);
  const [currentOrgId, setCurrentOrgId] = React.useState(undefined);

  const customerCount = customers?.length || 0;

  const handleView = (event, newView) => {
    setView(newView);
  };
  let history = useHistory();
  useEffect(() => {
    async function fetchData() {
      try {
        await Auth.currentAuthenticatedUser();
      } catch (error) {
        history && history.push("/sign-in");
      }
    }
    fetchData();
  }, [history]);

  useEffect(() => {
    init();
  }, []);
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  async function init() {
    try {
      let customers = await getUserCustomers();
      setCustomers(customers);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setCustomers([]);
      alert(error);
    }
  }

  const displayData = () => {
    switch (view) {
      case "list-view":
        return <CustomerListView isLoading={isLoading} rows={customers} />;

      case "card-view":
        return <CustomerCardView isLoading={isLoading} rows={customers} />;

      default:
        return (
          <CustomerTableView
            isLoading={isLoading}
            rows={customers}
            setCurrentOrgId={setCurrentOrgId}
            setCurrentCustomerId={setCurrentCustomerId}
            setOpenRemoveDialog={setOpenRemoveDialog}
          />
        );
    }
  };

  return (
    <Page title="FlukeWorks">
      <Header
        xl
        name={`All Clients (${customerCount})`}
        menuBar
        history={history}
        action={
          doesUserHavePermission ? (
            <Button
              variant="contained"
              color="primary"
              startIcon={<Add />}
              onClick={() => setOpenDialog(true)}
            >
              New Client
            </Button>
          ) : (
            ""
          )
        }
      />
      <Container maxWidth="xl" component="main" sx={{ my: 2 }}>
        <Box sx={{ my: 2 }}>
          <ToggleViews view={view} handleView={handleView} />
        </Box>
        {displayData()}
      </Container>
      <CreateCustomerDialog handleClose={handleCloseDialog} open={openDialog} />
      <RemoveCustomerDialog
        handleClose={() => {
          setCurrentCustomerId(undefined);
          setOpenRemoveDialog(false);
        }}
        currentCustomerId={currentCustomerId}
        currentOrgId={currentOrgId}
        open={openRemoveDialog}
        getUserCustomers={getUserCustomers}
        setCustomers={setCustomers}
      />
    </Page>
  );
};
